// extracted by mini-css-extract-plugin
export default {"videoCard":"VideoCard_videoCard__BvUs7","title":"VideoCard_title__9D4oV"};